import { useCallback, useEffect, useState } from 'react';

import { ancanaApi } from '../../../api/ancanaApi';
import { IPlan } from '../../../types/models/tenancy';

const PATH = 'tenancy/plans/';

/** The plans, whole (there are a handful; the endpoint isn't paginated). */
const usePlans = () => {
  const [plans, setPlans] = useState<IPlan[]>([]);

  const reload = useCallback(async () => {
    const response = await ancanaApi.get(PATH);
    setPlans(response.data?.results || response.data || []);
  }, []);

  useEffect(() => { reload().catch(() => setPlans([])); }, [reload]);

  const save = useCallback(async (plan: Partial<IPlan>) => {
    if (plan.id) await ancanaApi.patch(`${PATH}${plan.id}/`, plan);
    else await ancanaApi.post(PATH, plan);
    await reload();  // saving one can clear another's trial-default flag
  }, [reload]);

  const remove = useCallback(async (id: number) => {
    await ancanaApi.delete(`${PATH}${id}/`);
    await reload();
  }, [reload]);

  return { plans, reload, save, remove };
};

export default usePlans;
